export const iconFontAwesomeToggleSignal = (
	<i className="fa-solid fa-signal"></i>
);
